<template>
  <div id="app-container">
    <router-view/>
    <Toast position="bottom-right" />
  </div>
</template>

<script setup>
import { watch } from 'vue';
import { useThemeStore } from './stores/theme';
import { updatePreset } from '@primeuix/themes';
import Toast from 'primevue/toast';

const themeStore = useThemeStore();

watch(
  [() => themeStore.isDarkMode, () => themeStore.primaryColor],
  ([isDark, newColorName]) => {
    const newPreset = {
      semantic: {
        primary: {
          50: `{${newColorName}.50}`,
          100: `{${newColorName}.100}`,
          200: `{${newColorName}.200}`,
          300: `{${newColorName}.300}`,
          400: `{${newColorName}.400}`,
          500: `{${newColorName}.500}`,
          600: `{${newColorName}.600}`,
          700: `{${newColorName}.700}`,
          800: `{${newColorName}.800}`,
          900: `{${newColorName}.900}`,
          950: `{${newColorName}.950}`,
        },
      },
    };
    updatePreset(newPreset);

    // Set --accent-color for canvas animation
    const selectedColor = themeStore.availableColors.find(c => c.name === newColorName);
    if (selectedColor) {
        document.documentElement.style.setProperty('--accent-color', selectedColor.hex);
    }

    const htmlElement = document.documentElement;
    if (isDark) {
      htmlElement.classList.add('dark-theme');
    } else {
      htmlElement.classList.remove('dark-theme');
    }
  },
  { immediate: true }
);
</script>

<style>
/* Global reset and base font */
html, body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* DEBUG: Force sidebar background */
.app-sidebar {
  background-color: #ffffff !important;
}

.dark-theme .app-sidebar {
    background-color: #0a192f !important;
}

/* Dark mode styles for hamburger menu */
.dark-theme .hamburger-menu {
    background-color: #1f2937 !important;
    color: white !important;
    border: 1px solid white !important;
}
</style>